<div class="messages">
  <app-page-title icon="fa-paper-plane" [title]="title">
    <button class="btn btn-secondary" (click)="back()">Voltar</button>
  </app-page-title>

  <!-- Tabs -->
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <a class="nav-link"
         [class.active]="activeTab === 'automation'"
         (click)="onTabChange('automation')"
         style="cursor: pointer;">
        Automação
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link"
         [class.active]="activeTab === 'broadcast'"
         (click)="onTabChange('broadcast')"
         style="cursor: pointer;">
        Broadcast
      </a>
    </li>
  </ul>

  <app-skeleton *ngIf="loadingMessages" variant="table-row" [count]="8" [columns]="3"
    label="Carregando as mensagens enviadas" data-testid="messages-loading"></app-skeleton>

  <!-- Automation Tab Content -->
  <div *ngIf="activeTab === 'automation' && !loadingMessages">
    <div *ngIf="result?.data?.length > 0; else notFound">
      <app-accordion-panel
        *ngFor="let control of result?.data"
        [title]="control.message"
      >
        <div class="row message-line">
          <div class="col-md-3 col-sm-12"><i class="fa fa-user me-2"></i>{{ control.lead.name }}</div>
          <div class="col-md-3 col-sm-12"><i class="fa fa-phone me-2"></i>{{ control.lead.phone }}</div>
          <div class="col-md-3 col-sm-12"><i class="fa fa-calendar me-2"></i>{{ control.sent_date | date:'dd/MM/yyyy HH:mm' }}</div>
        </div>
      </app-accordion-panel>
    </div>
  </div>

  <!-- Broadcast Tab Content -->
  <div *ngIf="activeTab === 'broadcast' && !loadingMessages">
    <div *ngIf="broadcastResult?.data?.length > 0; else notFound">
      <app-accordion-panel
        *ngFor="let contact of broadcastResult?.data"
        [title]="contact.message"
      >
        <div class="row message-line">
          <div class="col-md-3 col-sm-12"><i class="fa fa-phone me-2"></i>{{ contact.phone }}</div>
          <div class="col-md-3 col-sm-12"><i class="fa fa-calendar me-2"></i>{{ contact.sent_date | date:'dd/MM/yyyy HH:mm' }}</div>
        </div>
      </app-accordion-panel>
    </div>
  </div>

  <ng-template #notFound>
    <div class="card">
      Nenhuma mensagem enviada
    </div>
  </ng-template>

  <app-pagination
    *ngIf="(activeTab === 'automation' && result) || (activeTab === 'broadcast' && broadcastResult)"
    [currentPage]="activeTab === 'automation' ? result?.current_page : broadcastResult?.current_page"
    [itemsPerPage]="activeTab === 'automation' ? result?.per_page : broadcastResult?.per_page"
    [totalItems]="activeTab === 'automation' ? result?.total : broadcastResult?.total"
    (pageChanged)="pageChanged($event)"
  ></app-pagination>
</div>
